module.exports = __webpack_public_path__ + "media/images/icon/two_player_bestball-986886bd79b44b0561b71f7af078bbe1.png";